const AuthoringSkeleton = () => {
  return (
    <div
      className="animate-pulse px-3 py-5 sm:px-5 md:px-9 min-[1030px]:p-8 xl:mx-1 xl:px-16"
      aria-label="Loading authoring library"
      role="status"
    >
      <span className="sr-only">Loading authoring library</span>

      <div className="mb-7 flex gap-4 overflow-hidden border-b border-gray-200 pb-3 dark:border-gray-700">
        {[1, 2, 3, 4, 5].map((tab) => (
          <div
            key={tab}
            className="h-9 w-40 shrink-0 rounded-md bg-gray-200 dark:bg-gray-700"
          />
        ))}
      </div>

      <div className="mb-5 flex flex-col gap-4 lg:flex-row lg:items-center">
        <div className="h-10 flex-1 rounded-md bg-gray-200 dark:bg-gray-700" />
        <div className="h-10 w-32 rounded-md bg-gray-200 dark:bg-gray-700" />
      </div>

      <div className="mb-9 grid grid-cols-1 gap-3 md:grid-cols-4">
        {[1, 2, 3, 4].map((filter) => (
          <div key={filter}>
            <div className="mb-2 h-4 w-16 rounded bg-gray-200 dark:bg-gray-700" />
            <div className="h-10 rounded-md bg-gray-200 dark:bg-gray-700" />
          </div>
        ))}
      </div>

      <div className="overflow-hidden rounded-lg border border-gray-200 dark:border-gray-700">
        <div className="grid grid-cols-[minmax(14rem,2fr)_repeat(3,minmax(6rem,1fr))] gap-4 border-b border-gray-200 p-4 dark:border-gray-700">
          {[1, 2, 3, 4].map((column) => (
            <div
              key={column}
              className="h-4 rounded bg-gray-200 dark:bg-gray-700"
            />
          ))}
        </div>
        {[1, 2, 3, 4, 5].map((row) => (
          <div
            key={row}
            className="grid grid-cols-[minmax(14rem,2fr)_repeat(3,minmax(6rem,1fr))] items-center gap-4 border-b border-gray-100 p-4 last:border-b-0 dark:border-gray-800"
          >
            <div className="flex items-center gap-3">
              <div className="size-12 shrink-0 rounded-md bg-gray-200 dark:bg-gray-700" />
              <div className="h-4 flex-1 rounded bg-gray-200 dark:bg-gray-700" />
            </div>
            {[1, 2, 3].map((cell) => (
              <div
                key={cell}
                className="h-7 rounded bg-gray-200 dark:bg-gray-700"
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AuthoringSkeleton;
